import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "instance-list-row" }
const _hoisted_2 = { class: "instance-list-row-text" }
const _hoisted_3 = {
  key: 0,
  class: "instance-list-row-fields text-body-2"
}
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "instance-list-row-value text-medium-emphasis" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "instance-list-row-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_color_accent = _resolveComponent("ontos-color-accent")!
  const _component_ontos_instance_identifier = _resolveComponent("ontos-instance-identifier")!
  const _component_ontos_property_value = _resolveComponent("ontos-property-value")!
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ontos_color_accent, {
      row: "",
      color: _ctx.instanceColorOf(_ctx.instance)
    }, null, 8, ["color"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ontos_instance_identifier, {
        instance: _ctx.instance,
        idea: _ctx.idea,
        class: "instance-list-row-title text-subtitle-1"
      }, null, 8, ["instance", "idea"]),
      (_ctx.fields.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: field.property.alias
              }, [
                _createElementVNode("span", {
                  class: "instance-list-row-label text-caption text-medium-emphasis",
                  title: field.property.name
                }, _toDisplayString(field.property.name), 9, _hoisted_4),
                _createElementVNode("span", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.values, (value, valueIndex) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: `${field.property.alias}.${valueIndex}`
                    }, [
                      (valueIndex > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, ", "))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ontos_property_value, {
                        property: field.property,
                        value: value,
                        item: _ctx.instance,
                        context: _ctx.context,
                        "choice-domains": _ctx.choiceDomains,
                        accent: false,
                        variant: "card"
                      }, null, 8, ["property", "value", "item", "context", "choice-domains"])
                    ], 64))
                  }), 128))
                ])
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.state)
      ? (_openBlock(), _createBlock(_component_ontos_colored_value, {
          key: 0,
          option: _ctx.state,
          form: "dot",
          class: "instance-list-row-state"
        }, null, 8, ["option"]))
      : _createCommentVNode("", true),
    (_ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
          _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}